import axios from "axios";

const API_URL = "/api/attendance";

// 🔹 Get all sessions
export const getSessions = async () => (await axios.get("/api/session")).data;

// 🔹 Get grades by session
export const getGrades = async (sessionId) =>
  (await axios.get("/api/grades", { params: { sessionId } })).data;

// 🔹 Get subjects by grade
export const getSubjectsByGrade = async (gradeId) =>
  (await axios.get("/api/subjects", { params: { gradeId } })).data;

// 🔹 Get students by grade
export const getStudentsByGrade = async (gradeId) =>
  (await axios.get("/api/students", { params: { gradeId } })).data;

// 🔹 Get attendance (filtered)
export const getAttendances = async (params) =>
  (await axios.get(API_URL, { params })).data;

// 🔹 Check if attendance exists for given filters
export const checkAttendance = async (params) =>
  (await axios.get(`${API_URL}/check`, { params })).data;

// 🔹 Save new attendance
export const saveAttendance = async (data) =>
  (await axios.post(API_URL, data)).data;

// 🔹 Update existing attendance
export const updateAttendance = async (id, data) =>
  (await axios.put(`${API_URL}/${id}`, data)).data;

// 🔹 Smart Save or Update Attendance (main function)
export const saveOrUpdateAttendance = async (data) => {
  const { sessionId, gradeId, subjectId, date } = data;

  try {
    // check attendance first
    const res = await axios.get(`${API_URL}/check`, {
      params: { sessionId, gradeId, subjectId, date },
    });

    if (res.data?.exists && res.data?.id) {
      // if exists -> update
      return await updateAttendance(res.data.id, data);
    } else {
      // else -> create new
      return await saveAttendance(data);
    }
  } catch (error) {
    console.error("❌ Error in saveOrUpdateAttendance:", error);
    throw error;
  }
};
